import { UserRole } from '~/types/account'
import type { User } from '~/types/account'
import type { Ref } from 'vue'
import { assertIsDefined } from '~/utils/assert'

type ServiceInstance = object
type ServiceConstructor = new () => ServiceInstance

interface Services {
  UserService: ServiceConstructor
  JoinService?: ServiceConstructor
  DemoService?: ServiceConstructor
}

class BaseProxyController {
  private joinService?: ServiceInstance
  private userService!: ServiceInstance
  private demoService?: ServiceInstance
  private user: Ref<User | null>

  constructor (services: Services) {
    const { user } = useSAuthState()
    this.user = user
    this.userService = new services.UserService()
    this.joinService = services.JoinService ? new services.JoinService() : undefined
    this.demoService = services.DemoService ? new services.DemoService() : new services.UserService()
  }

  get (_target: ServiceInstance, prop: string | symbol, _reciever: unknown) {
    const role = this.user.value?.role
    if (role === UserRole.Recruit) {
      assertIsDefined(this.joinService, 'joinService should be defined in getter of proxy for service')
      return Reflect.get(this.joinService, prop)
    } else if (role === UserRole.Demonstrator) {
      assertIsDefined(this.demoService, 'demoService should be defined in getter of proxy for service')
      return Reflect.get(this.demoService, prop)
    } else {
      return Reflect.get(this.userService, prop)
    }
  }
}

export default BaseProxyController
